import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: function () {
      return import(/* webpackChunkName: "home" */ '../views/Home.vue')
    }
  },
  {
    path: '/about',
    name: 'about',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
  {
    path: '/delivery',
    name: 'delivery',
    component: function () {
      return import(/* webpackChunkName: "delivery" */ '../views/Delivery.vue')
    }
  },
  {
    path: '/returns',
    name: 'returns',
    component: function () {
      return import(/* webpackChunkName: "returns" */ '../views/Returns.vue')
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: function () {
      return import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue')
    }
  },
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import(/* webpackChunkName: "login" */ '../views/Login.vue')
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: function () {
      return import(/* webpackChunkName: "admin" */ '../views/Admin.vue')
    },
    meta: { 
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

router.beforeEach((to, from, next) => {
  if(to.name === 'login') {
    if (store.getters['system/authStatus'] === 'success') {
      next('/admin')
    } 
  }

  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['system/authStatus'] === 'success') {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
})